const fileExtToMimeMap = {
  'flv': 'video/x-flv',
  'mp4': 'video/mp4',
  'm3u8': 'application/x-mpegURL',
  'ts': 'video/MP2T',
  '3gp': 'video/3gpp',
  'mov': 'video/quicktime',
  'avi': 'video/x-msvideo',
  'wmv': 'video/x-ms-wmv',
};

const FILE_EXTENSION_EXTRACTION_REGEX = /.*\.([0-9a-zA-Z]+)/;

const mimeTypeHelper = {
  get(fileExtension) {
    return fileExtToMimeMap[fileExtension];
  },
  parse(filepath = '') {
    const fileExtension = (filepath.match(FILE_EXTENSION_EXTRACTION_REGEX) || {})[1];
    return mimeTypeHelper.get(fileExtension);
  },
};

export default mimeTypeHelper;
